/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  WorkloadPlatformConstant,
  WorkloadPlatformConstant$inboundSchema,
} from "./workloadplatformconstant.js";
import {
  WorkloadPlatformStep,
  WorkloadPlatformStep$inboundSchema,
} from "./workloadplatformstep.js";
import {
  WorkloadPlatformSubject,
  WorkloadPlatformSubject$inboundSchema,
} from "./workloadplatformsubject.js";
import {
  WorkloadPlatformVariable,
  WorkloadPlatformVariable$inboundSchema,
} from "./workloadplatformvariable.js";

/**
 * A platform the catalog offers to trust, with what the operator supplies and the guided setup that connects it.
 */
export type WorkloadPlatform = {
  /**
   * What connecting the platform does.
   */
  description: string;
  /**
   * What the operator sees.
   */
  displayName: string;
  /**
   * False for a platform listed but not offered.
   */
  enabled: boolean;
  /**
   * The platform's logo, a path on the dashboard's origin. Empty where it has none.
   */
  icon: string;
  /**
   * A value a catalog platform supplies, the same for every customer.
   */
  issuer: WorkloadPlatformConstant;
  /**
   * A value a catalog platform supplies, the same for every customer.
   */
  jwksUri: WorkloadPlatformConstant;
  /**
   * Identifies the entry permanently.
   */
  key: string;
  /**
   * The guided setup. Empty for a platform without one, which is listed as coming soon and cannot be opened.
   */
  steps: Array<WorkloadPlatformStep>;
  /**
   * The access rule a catalog platform produces.
   */
  subject: WorkloadPlatformSubject;
  /**
   * What the operator supplies.
   */
  variables: Array<WorkloadPlatformVariable>;
};

/** @internal */
export const WorkloadPlatform$inboundSchema: z.ZodMiniType<
  WorkloadPlatform,
  unknown
> = z.pipe(
  z.object({
    description: z.string(),
    display_name: z.string(),
    enabled: z.boolean(),
    icon: z.string(),
    issuer: WorkloadPlatformConstant$inboundSchema,
    jwks_uri: WorkloadPlatformConstant$inboundSchema,
    key: z.string(),
    steps: z.array(WorkloadPlatformStep$inboundSchema),
    subject: WorkloadPlatformSubject$inboundSchema,
    variables: z.array(WorkloadPlatformVariable$inboundSchema),
  }),
  z.transform((v) => {
    return remap$(v, {
      "display_name": "displayName",
      "jwks_uri": "jwksUri",
    });
  }),
);

export function workloadPlatformFromJSON(
  jsonString: string,
): SafeParseResult<WorkloadPlatform, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => WorkloadPlatform$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'WorkloadPlatform' from JSON`,
  );
}
